import { AbstractQuery } from 'src/models/query';

export class MessageQuery extends AbstractQuery {
	name = 'IFS_Desktop_Query_Queries_Message_GetTheDetailsForTheMessageQuery';
	sort = [];

	constructor(aggregateId: string) {
		super();
		this.parameters.push({ aggregateId: aggregateId });
	}
}
